import { type DefaultError, useMutation, type UseMutationResult } from '@tanstack/react-query';
import { type RNPSupportRequest } from '@sr/types';
import { WithCustomerPortalApi } from 'core/customerPortalApi';
import { getApiUrl } from '#lib/utils/environment';

export const useRNPSupportRequest = WithCustomerPortalApi<
  boolean,
  UseMutationResult<boolean, DefaultError, RNPSupportRequest>
>(
  (fetchFn) => {
    return useMutation<boolean, DefaultError, RNPSupportRequest>({
      mutationKey: ['submit-rnp-support-request'],
      mutationFn: (data) =>
        fetchFn({
          url: `${getApiUrl()}/communication/rnp-support`,
          options: {
            method: 'POST',
            body: JSON.stringify(data),
          },
        }),
    });
  },
  { hookName: 'useRNPSupportRequest' },
);
